(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ftabsInit === '1') return;
    root.dataset.ftabsInit = '1';

    var tabs = root.querySelectorAll('.ftabs__tab');
    var panels = root.querySelectorAll('.ftabs__panel');
    var prevBtn = root.querySelector('[data-ftabs-prev]');
    var nextBtn = root.querySelector('[data-ftabs-next]');
    var viewport = root.querySelector('.ftabs__viewport');

    // Hide the chevrons when the active track has nothing to scroll
    // (fewer cards than fit the row). Re-checked on tab switch, resize,
    // and content changes (recently-viewed injects its cards after load).
    function updateArrows() {
      if (!viewport || (!prevBtn && !nextBtn)) return;
      var track = activeTrack();
      var overflows = !!track && track.scrollWidth > track.clientWidth + 1;
      viewport.classList.toggle('ftabs__viewport--static', !overflows);
    }

    function activate(index) {
      tabs.forEach(function (t) {
        var on = String(t.dataset.tabIndex) === String(index);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = String(p.dataset.tabPanel) === String(index);
        p.classList.toggle('is-active', on);
      });
      updateArrows();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.tabIndex);
      });
    });

    function activeTrack() {
      var panel = root.querySelector('.ftabs__panel.is-active');
      return panel ? panel.querySelector('[data-ftabs-track]') : null;
    }

    function scrollByCard(direction) {
      var track = activeTrack();
      if (!track) return;
      var card = track.querySelector('.ftabs__card');
      var step = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    updateArrows();
    window.addEventListener('resize', updateArrows);
    if ('MutationObserver' in window) {
      root.querySelectorAll('[data-ftabs-track]').forEach(function (track) {
        new MutationObserver(updateArrows).observe(track, { childList: true });
      });
    }
  }

  function bootAll() {
    document.querySelectorAll('[data-ftabs-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Re-run on Shopify section-load events (theme editor + hot reload)
  document.addEventListener('shopify:section:load', bootAll);
})();
